<template>
  <div class="text-center pb-3 px-3 pt-0">
    <h1 v-if="title">{{ title }}</h1>
    <img
      class="d-inline-block"
      v-if="platform === 'cryptotraffic'"
      src="@/assets/images/cryptotraffic/logo-wide.svg"
      style="width: 180px"
    />
    <img
      class="d-inline-block"
      v-if="platform === 'hprofits'"
      src="@/assets/images/hprofits/logo-wide.svg"
      style="width: 140px"
    />
    <img
      class="d-inline-block"
      v-if="platform === 'sportad'"
      src="@/assets/images/sportad/logo-wide.svg"
      style="width: 180px"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      platform: process.env.PLATFORM
    };
  }
};
</script>
